module.exports = __webpack_public_path__ + "assets/logo.jpg?cd22209867f4afe8a6807c911067f2f2";